import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import Card from "@mui/material/Card";
import Checkbox from "@mui/material/Checkbox";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import CoverLayout from "layouts/authentication/components/CoverLayout";
import bgImage from "assets/images/bg-sign-up-cover.jpeg";
import UserService from "services/UserService";
import { TextField } from "@mui/material";
import { useAuth } from "context/authContext";

function Cover() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [accepted, setAccepted] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  const passwordCompare = (value) => password === value && password.length >= 8;

  const getCreateUser = () => {
    return {
      "Email": email,
      "Name": name,
      "Password": password,
      "Main": false,
      "RoleId": 2,
    }
  }

  const handlePasswordValidate = (value) => {
    setConfirmPassword(value);

    if (!passwordCompare(value)) {
      setError({ type: "error", value: 'As senhas devem ser iguais e ter no minimo 8 caracteres.' })
    } else {
      setError("")
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!passwordCompare(confirmPassword)) {
      setError({ type: "error", value: 'As senhas devem ser iguais e ter no minimo 8 caracteres.' })
      return
    }
    setError("");

    try {
      const createUser = getCreateUser();
      await UserService.registerUser(createUser);
      navigate("/login", { state: { message: {type: 'success', msg: 'Cadastro realizado com sucesso!'} } });
    } catch (err) {
      setError({ type: "error", value: err.response?.data?.error || 'Erro ao realizar cadastro' });
    }
  };

  return (
    <CoverLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-3}
          p={3}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Faça seu cadastro
          </MDTypography>
          <MDTypography display="block" variant="button" color="white" my={1}>
            Insira seu nome, e-mail e senha para se cadastrar!
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form" onSubmit={handleSubmit} >
            <MDBox mb={2}>
              <TextField type="text" label="Nome" variant="standard" value={name} onChange={(e) => setName(e.target.value)} fullWidth required autoFocus />
            </MDBox>
            <MDBox mb={2}>
              <TextField type="email" label="Email" variant="standard" value={email} onChange={(e) => setEmail(e.target.value)} fullWidth required />
            </MDBox>
            <MDBox mb={2}>
              <TextField type="password" label="Senha" variant="standard" value={password} onChange={(e) => setPassword(e.target.value)} fullWidth required />
            </MDBox>
            <MDBox mb={2}>
              <TextField type="password" label="Confirmar senha" variant="standard" value={confirmPassword} onChange={(e) => handlePasswordValidate(e.target.value)} fullWidth required />
            </MDBox>
            {/* <MDBox display="flex" alignItems="center" ml={-1}>
              <Checkbox  onChange={() => setAccepted(!accepted)} />
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;Eu concordo com o&nbsp;
              </MDTypography>
              <MDTypography
                component="a"
                href="#"
                variant="button"
                fontWeight="bold"
                color="info"
                textGradient
              >
                Termos e Condições.
              </MDTypography>
            </MDBox> */}
            {error && (
              <MDBox mt={2}>
                <MDTypography variant="caption" color={error.type} fontWeight="light">
                  {error.value}
                </MDTypography>
              </MDBox>
            )}
            <MDBox mt={4} mb={1}>
              <MDButton variant="gradient" color="info" type="submit" fullWidth>
                cadastre-se
              </MDButton>
            </MDBox>
            <MDBox mt={3} mb={1} textAlign="center">
              <MDTypography variant="button" color="text">
                Já tem uma conta?&nbsp;
                <MDTypography
                  component={Link}
                  to="/login"
                  variant="button"  
                  color="info"
                  fontWeight="medium"
                  textGradient
                >
                  Entrar
                </MDTypography>
              </MDTypography>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </CoverLayout>
  );
}

export default Cover;
